import { useQuery } from '@tanstack/react-query';

import { AllowListItem } from 'src/features/allowList/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = 'sp-core/:parkingId/allow-lists/allow-list/:listId/allow-list-items/:itemId/';

type QueryFnType = typeof queryFn;

type DTO = {
    listId: string;
    itemId: string;
    parkingId: string;
};

const queryFn = ({ listId, itemId, parkingId }: DTO): Promise<AllowListItem> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, listId, itemId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetAllowListItem };
